import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { motion } from 'framer-motion';
import ReactTooltip from 'react-tooltip';

import fadeInUp from '../../helpers/Animations';

import { setContactDetailsModalOpen } from '../../actions/supporters';

import TableCell from './TableCell';

import '../../styles/components/_table.scss';

/*
 * Renders a row for SupportersTable
 */

const TableRow = ({ row, onRowClick, count }) => {
  useEffect(() => {
    ReactTooltip.rebuild();
  }, []);

  const handleRowClick = (canEdit) => onRowClick(row.original.id, canEdit);

  const handleKeyDown = (e) => {
    if (e.key === ' ' || e.key === 'Enter' || e.key === 'Spacebar') {
      e.preventDefault();
      onRowClick(row.original.id);
    }
  };

  const rowProps = row.getRowProps();

  return (
    <motion.div className="table__row" key={rowProps.key} animate={fadeInUp.animate} transition={fadeInUp.transition}>
      {row.cells.map((cell, index) => {
        const canEdit = cell.row.original.status !== 'Ceased';
        // eslint-disable-next-line react/no-array-index-key
        return (
          <TableCell
            cell={cell}
            key={`${cell.id}_${index}`}
            onClick={index === 0 ? () => handleRowClick(canEdit) : null}
            onKeyDown={index === 0 ? handleKeyDown : null}
            displayRowCount={index === 0 ? count : 0}
          />
        );
      })}
    </motion.div>
  );
};

TableRow.defaultProps = {
  onRowClick: null,
  count: 0,
};

TableRow.propTypes = {
  row: PropTypes.objectOf(PropTypes.any).isRequired,
  onRowClick: PropTypes.func,
  count: PropTypes.number,
};

const mapDispatchToProps = (dispatch) => ({
  onRowClick: (contactID) => dispatch(setContactDetailsModalOpen(contactID)),
});

const mapStateToProps = (state) => ({
  searchQuery: state.reports.table.query,
});

export default connect(mapStateToProps, mapDispatchToProps)(TableRow);
